var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"24","viewBox":"0 0 18 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 0H3C1.34 0 0 1.34 0 3V21C0 22.66 1.34 24 3 24H15C16.66 24 18 22.66 18 21V3C18 1.34 16.66 0 15 0ZM11 22H7V21H11V22ZM16.25 19H1.75V3H16.25V19Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }